module.exports = __webpack_public_path__ + "files/262a63bbf4c56d7ef0e0a9e72993ed93.svg";